import { getRoutes } from "../utilities/routes";

export interface FollowupScheduleSms {
  id: number;
  followupScheduleRef: number;
  serviceRef?: number | null;
  groupRef?: number | null;
  customerRef?: string | null;
  agreementRef?: number | null;
  groupTitle?: string | null;
  serviceName?: string | null;
  scheduleTitle?: string | null;
  customerName?: string | null;
  sendAt?: string | null;
  message: string;
  status: number;
  sentOn?: string | null;
  error?: string | null;
  isPaymentReminder?: boolean;
  paymentAlertDayLeft?: number | null;
}

export interface PagedResult<T> {
  items: T[];
  totalCount: number;
  page: number;
  pageSize: number;
}

export interface ApiResponse<T> {
  status: boolean;
  data: T;
  message?: string;
}

export interface SmsFilter {
  page?: number;
  pageSize?: number;
  followupScheduleId?: number;
  groupRef?: number;
  serviceRef?: number;
  customerRef?: string;
  agreementRef?: number;
  customerName?: string;
}

export async function fetchSmsList(
  token: string,
  filters: SmsFilter = {}
): Promise<PagedResult<FollowupScheduleSms>> {
  const routes = getRoutes();
  const params = new URLSearchParams();
  if (filters.page !== undefined) params.append("page", String(filters.page));
  if (filters.pageSize !== undefined)
    params.append("pageSize", String(filters.pageSize));
  if (filters.followupScheduleId !== undefined)
    params.append("followupScheduleId", String(filters.followupScheduleId));
  if (filters.groupRef !== undefined)
    params.append("groupRef", String(filters.groupRef));
  if (filters.serviceRef !== undefined)
    params.append("serviceRef", String(filters.serviceRef));
  if (filters.customerRef) params.append("customerRef", filters.customerRef);
  if (filters.agreementRef !== undefined)
    params.append("agreementRef", String(filters.agreementRef));
  if (filters.customerName) params.append("customerName", filters.customerName);

  const response = await fetch(
    `${routes.FollowupScheduleSmsRoutes}?${params.toString()}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => null);
    const errorMessage =
      errorData?.message ||
      errorData?.title ||
      `Failed to fetch followup schedule sms: ${response.statusText}`;
    throw new Error(errorMessage);
  }

  const json: ApiResponse<PagedResult<FollowupScheduleSms>> =
    await response.json();
  return json.data;
}

export async function deleteBulkSms(
  token: string,
  smsIds: number[]
): Promise<{ deletedCount: number; message: string }> {
  const routes = getRoutes();
  const response = await fetch(`${routes.FollowupScheduleSmsRoutes}/bulk`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(smsIds),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => null);
    const errorMessage =
      errorData?.data ||
      errorData?.message ||
      errorData?.title ||
      `Failed to delete SMS: ${response.statusText}`;
    throw new Error(errorMessage);
  }

  const json: ApiResponse<{ deletedCount: number; message: string }> =
    await response.json();
  return json.data;
}
